/** CMS slug for the site homepage (resolves to `/` in routing). */
export const HOME_PAGE_SLUG = "hem";

const LEGACY_HOME_PAGE_SLUG = "home";

export function isHomePageSlug(slug?: string | null): boolean {
  return !slug || slug === HOME_PAGE_SLUG || slug === LEGACY_HOME_PAGE_SLUG;
}
